// KOA-5857 — Pure wire-format builder for the table-editor save batch.
//
// Lives in its own module so callers (and tests) can import it without
// transitively dragging in `TableEditorService`, which itself transits
// through the auth layer and explodes during unit tests. Splitting it
// here keeps `buildBatchRequestFromPending` import-safe in any
// environment (node, jsdom, generated-app runtime) without changing
// the runtime contract.

import type { IManagedDbBatchRequest, IManagedDbRowMutation } from "../../services/table-editor-service";
import {
  IPendingChanges,
  IPendingRowInsert,
  IPendingRowUpdate,
  isPersistableInsert,
  rowPkStringToKey,
  RowPkString
} from "./pending-changes-reducer";

export const buildBatchRequestFromPending = (
  tableName: string,
  tableSchema: string | undefined,
  pending: IPendingChanges,
  atomic: boolean
): IManagedDbBatchRequest => {
  const mutations: IManagedDbRowMutation[] = [];
  pending.deletes.forEach((pk: RowPkString): void => {
    mutations.push({
      clientId: pk,
      op: "delete",
      key: { keys: rowPkStringToKey(pk) }
    });
  });
  pending.updates.forEach((update: IPendingRowUpdate, pk: RowPkString): void => {
    mutations.push({
      clientId: pk,
      op: "update",
      key: { keys: rowPkStringToKey(pk) },
      values: update.changes,
      originalValues: update.originals
    });
  });
  pending.inserts.filter(isPersistableInsert).forEach((insert: IPendingRowInsert): void => {
    mutations.push({ clientId: insert.clientId, op: "insert", values: insert.values });
  });
  return { tableName, tableSchema, mutations, atomic };
};
